import './plugins'
import router from './router'
import App from './Auth'
import Vue from 'vue'

window.Vue = Vue

Vue.config.debug = true

let vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.vm = vm



// WEBPACK FOOTER //
// ./resources/js/auth/auth.js